var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShapePolygonPlus = function SvgShapePolygonPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 15.7V13h2v4l-9 4-7-7 4-9h4v2H8.3l-2.9 6.6 5 5zM22 5v2h-3v3h-2V7h-3V5h3V2h2v3z"
  })));
};
export { SvgShapePolygonPlus as ReactComponent };
export default "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M17 15.7V13H19V17L10 21L3 14L7 5H11V7H8.3L5.4 13.6L10.4 18.6L17 15.7V15.7ZM22 5V7H19V10H17V7H14V5H17V2H19V5H22Z' fill='%234A6067'/%3e %3c/svg%3e";